import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Product } from '../../data/products';
interface ProductCardProps {
  product: Product;
  index: number;
}
export function ProductCard({
  product,
  index
}: ProductCardProps) {
  const Icon = product.icon;
  const colorClasses = {
    indigo: 'bg-indigo-100 text-indigo-600 group-hover:bg-indigo-600 group-hover:text-white',
    teal: 'bg-teal-100 text-teal-600 group-hover:bg-teal-600 group-hover:text-white',
    amber: 'bg-amber-100 text-amber-600 group-hover:bg-amber-600 group-hover:text-white',
    emerald: 'bg-emerald-100 text-emerald-600 group-hover:bg-emerald-600 group-hover:text-white',
    violet: 'bg-violet-100 text-violet-600 group-hover:bg-violet-600 group-hover:text-white',
    rose: 'bg-rose-100 text-rose-600 group-hover:bg-rose-600 group-hover:text-white'
  };
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5,
    delay: index * 0.1
  }} className="group h-full" data-id="element-257">
      <Link to={`/products/${product.id}`} className="block h-full bg-white rounded-2xl p-8 border border-slate-100 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex flex-col" data-id="element-258">
        <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-6 transition-colors duration-300 ${colorClasses[product.color]}`} data-id="element-259">
          {product.logoUrl ? <img src={product.logoUrl} alt={`${product.name} logo`} className="w-8 h-8 object-contain" data-id="element-260" /> : <Icon size={24} data-id="element-261" />}
        </div>

        <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-262">
          {product.name}
        </h3>
        <p className="text-slate-600 mb-6 flex-grow" data-id="element-263">{product.tagline}</p>

        <div className="flex items-center text-navy-600 font-medium mt-auto group-hover:translate-x-1 transition-transform duration-300" data-id="element-264">
          Learn More <ArrowRight size={16} className="ml-2" data-id="element-265" />
        </div>
      </Link>
    </motion.div>;
}